export const API_PATH = process.env.NODE_ENV === 'development' ? "/" : "https://api-dot-clarity-dev-376817.wl.r.appspot.com/"